
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { defaultNS, fallbackLng } from './constants';
import { defaultResources } from './defaultResources';
import { landingTranslations } from './languages';
import { loadTranslationsFromDb, loadTranslationsFromStorage } from './utils';
import { extendI18n, setupStorageListeners } from './methods';
import './types';

// Merge default resources with landing translations
const mergedResources = {
  en: {
    common: { ...defaultResources.en.common, ...landingTranslations.en.common }
  },
  es: {
    common: { ...defaultResources.es.common, ...landingTranslations.es.common }
  },
  no: {
    common: { ...defaultResources.no.common, ...landingTranslations.no.common }
  }
};

// Initialize i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng,
    defaultNS,
    ns: ['common'],
    interpolation: {
      escapeValue: false,
    },
    resources: mergedResources,
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged loaded',
    }
  });

// Extend i18n with custom methods
extendI18n();

// Setup cross-tab synchronization
setupStorageListeners();

// Initialize last update timestamp
window.__lastTranslationUpdate = 0;

// Load translations initially
loadTranslationsFromDb().then(dbResources => {
  if (dbResources) {
    // Merge DB resources with landing translations to ensure we have them
    const mergedDbResources = {
      en: {
        common: { ...(dbResources.en?.common || {}), ...landingTranslations.en.common }
      },
      es: {
        common: { ...(dbResources.es?.common || {}), ...landingTranslations.es.common }
      },
      no: {
        common: { ...(dbResources.no?.common || {}), ...landingTranslations.no.common }
      }
    };
    
    if (i18n.options) {
      i18n.options.resources = mergedDbResources;
      
      localStorage.setItem('i18nextResources', JSON.stringify(mergedDbResources));
      
      i18n.reloadResources().then(() => {
        console.log("Translations loaded from database and applied");
        
        const currentLang = i18n.language;
        i18n.changeLanguage(currentLang).then(() => {
          console.log(`Language explicitly set to ${currentLang} after loading translations`);
          document.dispatchEvent(new CustomEvent('translationsUpdated'));
        });
      });
    }
  } else {
    const storageResources = loadTranslationsFromStorage();
    if (storageResources && i18n.options) {
      // Merge storage resources with landing translations
      const mergedStorageResources = {
        en: {
          common: { ...(storageResources.en?.common || {}), ...landingTranslations.en.common }
        },
        es: {
          common: { ...(storageResources.es?.common || {}), ...landingTranslations.es.common }
        },
        no: {
          common: { ...(storageResources.no?.common || {}), ...landingTranslations.no.common }
        }
      };
      
      i18n.options.resources = mergedStorageResources;
      i18n.reloadResources().then(() => {
        console.log("Translations loaded from localStorage");
        document.dispatchEvent(new CustomEvent('translationsUpdated'));
      });
    }
  }
});

export default i18n;
